import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, FormControl } from 'react-bootstrap'
import * as request from 'services/request'

class UpdateTenantModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      name: ''
    }

    this.handleNameChanged = this.handleNameChanged.bind(this)
    this.save = this.save.bind(this)
  }

  handleNameChanged (e) {
    this.setState({ name: e.target.value })
  }

  async save () {
    const { id, onClose } = this.props
    const { name } = this.state

    await request.authorized(`/tenants/${id}`, {
      method: 'PUT',
      body: { name }
    })

    this.setState({ name: '' })
    onClose()
  }

  render () {
    const { name, show, onClose } = this.props

    return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Update Tenant</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FormControl
            type='text'
            placeholder='Tenant Name'
            defaultValue={name}
            onChange={this.handleNameChanged}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onClose}>Cancel</Button>
          <Button bsStyle='primary' onClick={this.save}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

UpdateTenantModal.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func
}

export default UpdateTenantModal



// WEBPACK FOOTER //
// ./src/pages/admin/tenants/update-modal.js